export default "__VITE_ASSET__7ph1CZZZ__"